import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './advanced-search.component.scss';
var AdvancedSearch = /** @class */ (function (_super) {
    tslib_1.__extends(AdvancedSearch, _super);
    function AdvancedSearch(element) {
        return _super.call(this, element) || this;
    }
    AdvancedSearch.prototype.init = function () {
        this.modal = this.element.querySelector('.js-advanced-search-modal');
        this.openButton = this.element.querySelector('.js-advanced-search-modal-open');
        this.closeButton = this.element.querySelector('.js-advanced-search-modal-close');
        this.filterForm = this.element.querySelector('form');
        this.filterFormSubmitButton = this.element.querySelector('.js-submit-advanced-search-filter');
        this.additionalFields = this.element.querySelector('.js-advanced-search-additional');
        this.additionalFieldsToggle = Array.from(this.element.querySelectorAll('.js-advanced-search-additional-toggle'));
        this.additionalFieldsOne = this.element.querySelector('.js-advanced-search-additional-one');
        this.additionalFieldsTwo = this.element.querySelector('.js-advanced-search-additional-two');
        this.additionalFieldsOpenButton = this.element.querySelector('.js-advanced-search-additional-open');
        this.toggleAdditionalFieldsButtonStateOnAction('disable');
    };
    AdvancedSearch.prototype.bindEvents = function () {
        var _this = this;
        this.element.addEventListener('click', function (event) { return _this.isClickOutsideModal(event); });
        this.openButton.addEventListener('click', function (event) { return _this.openModal(); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.filterFormSubmitButton.addEventListener('click', function () { return _this.submitForm(); });
        this.additionalFieldsOne.addEventListener('input', function () { return _this.toggleAdditionalFieldsButtonStateOnInput(); });
        this.additionalFieldsToggle.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleAdditionalFields(event);
        }); });
    };
    AdvancedSearch.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.modal) {
            this.closeModal();
        }
    };
    AdvancedSearch.prototype.closeModal = function () {
        var _this = this;
        this.modal.classList.add('modal--close');
        setTimeout(function () {
            _this.modal.classList.add('modal--closed');
        }, 250);
    };
    AdvancedSearch.prototype.openModal = function () {
        this.modal.classList.remove('modal--close');
        this.modal.classList.remove('modal--closed');
    };
    AdvancedSearch.prototype.toggleAdditionalFields = function (event) {
        if (event.currentTarget.classList.contains('button--disabled')) {
            return;
        }
        this.additionalFieldsTwo.value = '';
        if (this.additionalFields.classList.contains('advanced-search__additional--open')) {
            this.additionalFields.classList.remove('advanced-search__additional--open');
            this.toggleAdditionalFieldsButtonStateOnAction('enable');
        }
        else {
            this.additionalFields.classList.add('advanced-search__additional--open');
            this.toggleAdditionalFieldsButtonStateOnAction('disable');
        }
    };
    AdvancedSearch.prototype.toggleAdditionalFieldsButtonStateOnAction = function (action) {
        if (action === 'disable') {
            this.additionalFieldsOpenButton.classList.add('button--disabled');
        }
        else {
            this.additionalFieldsOpenButton.classList.remove('button--disabled');
        }
    };
    AdvancedSearch.prototype.toggleAdditionalFieldsButtonStateOnInput = function () {
        if (this.additionalFieldsOne.value !== '') {
            this.toggleAdditionalFieldsButtonStateOnAction('enable');
        }
        else {
            this.toggleAdditionalFieldsButtonStateOnAction('disable');
        }
    };
    AdvancedSearch.prototype.submitForm = function () {
        console.log(this.serializeForm());
        this.closeModal();
    };
    AdvancedSearch.prototype.serializeForm = function () {
        var field, result = [];
        if (typeof this.filterForm === 'object' && this.filterForm.nodeName === 'FORM') {
            var fieldsLen = this.filterForm.elements.length;
            for (var i = 0; i < fieldsLen; i++) {
                field = this.filterForm.elements[i];
                if (this.isOptionField(field)) {
                    result[result.length] = {
                        name: field.name,
                        value: field.value
                    };
                }
                if (this.isTextField(field)) {
                    result[result.length] = {
                        name: field.name,
                        value: field.value
                    };
                }
            }
        }
        return result;
    };
    AdvancedSearch.prototype.isOptionField = function (field) {
        return ((field.type === 'checkbox' || field.type === 'radio') && field.checked);
    };
    AdvancedSearch.prototype.isTextField = function (field) {
        return (field.type === 'text');
    };
    return AdvancedSearch;
}(Base));
export { AdvancedSearch };



//////////////////
// WEBPACK FOOTER
// ./components/advanced-search/advanced-search.component.ts
// module id = 87
// module chunks = 0